<div class="indicator {{data.className}} {{data.className + value[data.columnName]}}">
  <div *ngIf="indicatorEvaluation" class="aberration-warning">
    <span>{{displayValue}}</span>
  </div>
</div>
